<template>
  <q-page class="main-wrapper-page single-page" style="background-color: var(--q-accent)">
    <div v-if="loadData" class="widget-section">
      <div class="flex items-center justify-between q-mb-md block-label">
        <span class="label-block">Environments:</span>
        <q-btn
          flat
          no-caps
          class="q-ml-md btn--no-hover text-weight-regular"
          round
          color="light-blue-5"
          size="15px"
          style="min-height: 30px"
          :disabled="addEnvError?.length"
          :ripple="false"
          @click="showForm = true"
        >
          + Add Environment
          <q-tooltip v-if="addEnvError?.length">{{ addEnvError }}</q-tooltip>
        </q-btn>
      </div>
      <div v-if="showForm" class="env-form hide-label">
        <div class="flex items-start no-wrap">
          <div class="full-width">
            <q-banner v-if="generalErrors.length" class="text-white approval-error-banner q-mt-sm q-mb-sm">
              <span class="flex items-center" v-for="(error, key) in generalErrors" :key="key">
                <q-icon name="error" class="q-mr-xs" size="16px"></q-icon>{{ error.message }}
              </span>
            </q-banner>
            <json-forms
              :data="formData"
              :renderers="renderers"
              :schema="schema"
              :uischema="uiSchema"
              @change="onChange"
            />
            <div class="q-px-sm q-mt-md">
              <json-forms
                v-if="newEnvs.length && !details"
                :data="formDataDetails"
                :renderers="renderers"
                :schema="detailsSchema"
                :uischema="detailsUiSchema"
                @change="validateDetails"
              />
            </div>
          </div>

          <div class="btns flex items-center justify-end q-ml-auto q-mt-lg">
            <q-btn
              @click="send"
              no-caps
              text-color="dark"
              :loading="loadSend"
              :disabled="
                environments.length === formData.environments.length ||
                storedEnvironments().length === formData.environments.length ||
                loadSend ||
                submitDisable ||
                Boolean(formErrors.length) ||
                Boolean(detailsFormErrors.length) ||
                Boolean(errors.length) ||
                Boolean(generalErrors.length)
              "
              color="primary"
              >Save</q-btn
            >
            <q-btn @click="closeForm" :ripple="false" class="btn--no-hover" no-caps flat>Cancel</q-btn>
          </div>
        </div>
        <div v-if="summary?.composition?.length && !loadSummary" class="q-px-sm">
          <div class="summary">{{ summary?.summaryText }}</div>
          <ul class="roles">
            <li v-for="(item, index) in summary?.composition" :key="index">
              {{ item.displayName }}
            </li>
          </ul>
        </div>
      </div>
      <ul v-if="environments.length || storedEnvironments().length">
        <li class="q-mb-xs" v-for="(environment, key) in environments" :key="key">
          {{ environment.value }}
          <StatusCell showLabel :status="environment.status" class="q-ml-auto" />
          <WorkflowsBtn
            class="q-ml-md"
            @showWorkflow="showWorkflow($event, environment.id)"
            :relatedWorkflowStatuses="relatedWorkflowStatuses.find((i) => i.id === environment.id)?.statuses || []"
          />
          <ondemand-button
            label="Offboard"
            icon="sym_o_delete"
            @lockClick="validateOffboard(environment)"
            @unlockClick="openConfirmationPopUp(environment)"
            :loading="loadEnv === environment.value"
            :state="unlockEnvsForOffboard.includes(environment.value) ? 'unlock' : 'lock'"
            :errorMessage="disableOffboardEnvs[environment.value]"
            class="q-ml-sm"
          />
        </li>
        <li class="q-mb-xs" v-for="(environment, key) in storedEnvironments()" :key="key">
          {{ environment }}
          <q-spinner size="18px" class="q-ml-auto"> </q-spinner>
          <q-tooltip>Workflow in the process of creation... </q-tooltip>
        </li>
      </ul>
    </div>
    <div class="widget-section q-mt-lg">
      <div class="flex items-center justify-between q-mb-md">
        <span class="label-block">Additional Information:</span>
      </div>
      <ul class="details">
        <li>
          <q-spinner v-if="!details && (environments?.length || storedEnvironments?.length)" size="18px"></q-spinner>
          <b>Business Area:</b>
          <div class="q-ml-auto">
            <q-spinner v-if="!details && (environments?.length || storedEnvironments?.length)" size="18px"></q-spinner>
            <span v-else>{{ details?.businessArea || 'n/a' }}</span>
          </div>
        </li>
        <li>
          <q-spinner v-if="!details && (environments?.length || storedEnvironments?.length)" size="18px"></q-spinner>
          <b>Data Classification:</b>
          <div class="q-ml-auto">
            <q-spinner v-if="!details && (environments?.length || storedEnvironments?.length)" size="18px"></q-spinner>
            <span v-else>{{ details?.dataClassification || 'n/a' }}</span>
          </div>
        </li>
        <li>
          <q-spinner v-if="!details && (environments?.length || storedEnvironments?.length)" size="18px"></q-spinner>
          <b>IT Domain:</b>
          <div class="q-ml-auto">
            <q-spinner v-if="!details && (environments?.length || storedEnvironments?.length)" size="18px"></q-spinner>
            <span v-else>{{ details?.itDomain || 'n/a' }}</span>
          </div>
        </li>
      </ul>
    </div>
  </q-page>

  <q-dialog v-model="confirmOffboardPopup" class="single-service-page" persistent>
    <q-card style="min-width: 768px; border-radius: 0px">
      <q-toolbar class="shadow-2 q-py-sm q-px-md">
        <q-toolbar-title class="text-weight-bold">
          <strong>Are you sure?</strong>
        </q-toolbar-title>
        <q-btn icon="close" round flat class="btn--no-hover" @click="confirmOffboardPopup = false"></q-btn>
      </q-toolbar>
      <q-card-section class="q-mx-md q-px-none q-pb-none" style="border-top: 2px solid var(--q-primary)">
        <p>
          You are about to offboard <strong>{{ registrationData.infrastructureServiceApm }}</strong> from
          <strong>{{ registrationData.digitalServiceApm }}</strong> on <strong>{{ offboardEnv.value }}</strong
          >. Please, keep in mind that before you can offboard application, you should:
        </p>
        <ul>
          <li>Remove all DBAAS resources (schemas, databases etc.)</li>
        </ul>
        <p>If above conditions are met, you can proceed with this action.</p>
        <p>
          A SNOW Inquiry will be submitted on your behalf, for <b>IAM</b> team, in order to
          <b>decommission related access products.</b>
        </p>
      </q-card-section>
      <q-card-actions class="q-pb-md">
        <q-btn color="primary" @click="offboardRegistration" size="md" class="q-ml-sm" no-caps>Yes</q-btn>
        <q-btn flat size="md" class="btn--no-hover" style="height: 40px" no-caps @click="confirmOffboardPopup = false"
          >No</q-btn
        >
      </q-card-actions>
    </q-card>
  </q-dialog>
</template>

<script>
import { JsonForms } from '@jsonforms/vue';
import { quasarRenderers } from '@/shared/jsonformsQuasarRenderers/renderers';
import StatusCell from './registration-network/components/StatusCell.vue';
import {
  getRegistration,
  subValWorkflow,
  getBluePrint,
  validateWorkFlow,
  createWorkFlow,
  getRelatedWorkflowsStatuses,
  getSummary,
} from '../api/api';
import { supportCntrlClick } from '@/shared/helpers';
import WorkflowsBtn from '@/shared/components/WorkflowsBtn.vue';
import OndemandButton from '@/shared/components/OndemandButton.vue';

const renderers = [...quasarRenderers];

export default {
  name: 'RegistrationDBaaS',
  props: {
    registrationId: {
      type: String,
    },
    registrationData: {
      type: Object,
    },
  },
  components: {
    JsonForms,
    StatusCell,
    WorkflowsBtn,
    OndemandButton,
  },
  data() {
    return {
      submitDisable: true,
      renderers: Object.freeze(renderers),
      schema: {
        description: 'A set of attributes defining the state of an object',
        type: 'object',
        properties: {
          environments: {
            type: 'array',
            uniqueItems: true,
            maxItems: 3,
            items: {
              type: 'string',
              enum: ['DEV', 'NONPROD', 'PROD'],
            },
          },
        },
      },
      showForm: false,
      addEnvError: undefined,
      uiSchema: {
        type: 'VerticalLayout',
        elements: [
          {
            type: 'Control',
            scope: '#/properties/environments',
          },
        ],
      },
      formData: {
        environments: [],
      },
      formDataDetails: {
        digitalServiceApmId: this.registrationData.digitalServiceApm,
      },
      detailsUiSchema: {
        type: 'HorizontalLayout',
        elements: [
          {
            type: 'Control',
            scope: '#/properties/business_area',
            label: 'Business Area',
            options: {
              editable: false,
            },
          },
          {
            type: 'Control',
            scope: '#/properties/data_classification',
            label: 'Data Classification',
            options: {
              editable: false,
            },
          },
          {
            type: 'Control',
            scope: '#/properties/it_domain',
            label: 'IT Domain',
            options: {
              editable: false,
            },
          },
        ],
      },
      detailsSchema: {},
      details: undefined,
      loadData: false,
      validationTimeout: undefined,
      formErrors: [],
      detailsFormErrors: [],
      errors: [],
      generalErrors: [],
      loadSend: false,
      relatedWorkflowStatuses: [],
      loadSummary: false,
      summary: undefined,
      loadEnv: undefined,
      offboardEnv: undefined,
      disableOffboardEnvs: [],
      unlockEnvsForOffboard: [],
      confirmOffboardPopup: false,
    };
  },
  computed: {
    newEnvs() {
      return this.formData.environments
        .filter((env) => !this.environments.find((e) => env === e.value))
        .filter((env) => !this.storedEnvironments().find((e) => env === e));
    },
  },
  methods: {
    offboardRegistration() {
      const payload = {
        workflowId: 'engprt.offboard-application-dbaas',
        inputVariables: {
          digitalServiceApmId: this.registrationData.digitalServiceApm,
          infraServiceApmId: this.registrationData.infrastructureServiceApm,
          environmentId: this.offboardEnv.value,
        },
      };
      createWorkFlow(payload)
        .then(() => {
          this.$notify('positive', 'Success', 'Offboarding started successfull.');
        })
        .catch((error) => {
          this.$notify('negative', 'Error', error.message);
        })
        .finally(async () => {
          this.confirmOffboardPopup = false;
          await this.load();
        });
    },
    validateOffboard(env) {
      this.loadEnv = env.value;
      const offboardPayload = {
        workflowId: 'engprt.offboard-application-dbaas',
        inputVariables: {
          digitalServiceApmId: this.registrationData.digitalServiceApm,
          infraServiceApmId: this.registrationData.infrastructureServiceApm,
          environmentId: env.value,
        },
      };
      validateWorkFlow(offboardPayload)
        .then(() => {
          this.unlockEnvsForOffboard.push(env.value);
        })
        .catch((error) => {
          this.disableOffboardEnvs[env.value] = error.message;
        })
        .finally(() => {
          this.loadEnv = undefined;
        });
    },
    openConfirmationPopUp(env) {
      this.confirmOffboardPopup = true;
      this.offboardEnv = env;
    },
    closeForm() {
      this.showForm = false;
      this.formData.environments = this.environments.map((env) => env.value);
      this.formDataDetails = {
        digitalServiceApmId: this.registrationData.digitalServiceApm,
      };
      this.generalErrors = [];
      this.errors = [];
      this.formErrors = [];
      this.detailsFormErrors = [];
      this.submitDisable = true;
      this.summary = undefined;
      this.loadSend = false;
      this.loadSummary = false;
      if (this.validationTimeout) clearTimeout(this.validationTimeout);
    },
    async send() {
      const promises = this.newEnvs.map((env) => {
        const data = {
          workflowId: 'engprt.onboard-application-default',
          inputVariables: {
            digitalServiceApmId: this.registrationData.digitalServiceApm,
            infraServiceApmId: this.registrationData.infrastructureServiceApm,
            environmentId: env,
          },
        };
        return createWorkFlow(data)
          .then(() => {
            this.$notify('positive', 'Success', `${env} environment was added successfull.`);
            let storedData = JSON.parse(localStorage.getItem('registrationData')) || {};

            storedData[this.registrationId] = storedData[this.registrationId] || [];
            if (!storedData[this.registrationId].includes(env)) {
              storedData[this.registrationId].push(env);
            }
            localStorage.setItem('registrationData', JSON.stringify(storedData));
          })
          .catch((error) => {
            this.$notify('negative', 'Error', error.message);
          });
      });
      if (Object.values(this.formDataDetails).length > 1) {
        const detailsPromise = createWorkFlow({
          workflowId: 'engprt.post-onboarding-dbaas',
          inputVariables: this.formDataDetails,
        })
          .then(() => {
            this.$notify('positive', 'Success', 'The post onboarding process started successfull.');
          })
          .catch((error) => {
            this.$notify('negative', 'Error', error.message);
          });
        promises.push(detailsPromise);
      }

      await Promise.all([...promises]).finally(async () => {
        this.loadSernd = false;
        this.closeForm();
        await this.load();
      });
    },
    validateDetails(value) {
      this.detailsFormErrors = value.errors;
      if (JSON.stringify(value.data) !== JSON.stringify(this.formDataDetails) && !value.errors.length) {
        this.detailsFormErrors = value.errors;
        this.formDataDetails = value.data;
        this.loadSend = true;
        if (this.validationTimeout) clearTimeout(this.validationTimeout);
        this.validationTimeout = setTimeout(async () => {
          try {
            const workFlowData = {
              workflowId: 'engprt.post-onboarding-dbaas',
              inputVariables: this.formDataDetails,
            };
            await validateWorkFlow(workFlowData);
            this.errors = [];
            this.generalErrors = [];
            this.submitDisable = false;
          } catch (error) {
            if (error?.response?.data?.errors?.length) {
              this.errors = error.response.data.errors.filter((error) => error.instancePath.length);
              this.generalErrors = error.response.data.errors.filter((error) => !error.instancePath.length) || [];
            } else {
              this.$notify('negative', 'Error', error.message);
              this.errors = [];
              this.generalErrors = [];
              clearTimeout(this.validationTimeout);
            }
          } finally {
            this.loadSend = false;
          }
        }, 1500);
      }
    },
    onChange(value) {
      this.formErrors = value.errors;
      if (JSON.stringify(value.data) !== JSON.stringify(this.formData) && !value.errors.length) {
        this.formErrors = value.errors;
        this.formData = value.data;
        this.loadSend = true;
        this.loadSummary = true;

        if (this.validationTimeout) clearTimeout(this.validationTimeout);
        this.validationTimeout = setTimeout(async () => {
          const validationPromises = this.newEnvs.map(async (env) => {
            return validateWorkFlow({
              workflowId: 'engprt.onboard-application-default',
              inputVariables: {
                digitalServiceApmId: this.registrationData.digitalServiceApm,
                infraServiceApmId: this.registrationData.infrastructureServiceApm,
                environmentId: env,
              },
            })
              .then(() => {
                this.errors = [];
                this.generalErrors = [];
                this.submitDisable = false;
              })
              .catch((error) => {
                if (error?.response?.data?.errors?.length) {
                  this.errors = error.response.data.errors.filter((error) => error.instancePath.length);
                  this.generalErrors = error.response.data.errors.filter((error) => !error.instancePath.length) || [];
                } else {
                  this.$notify('negative', 'Error', error.message);
                  this.errors = [];
                  this.generalErrors = [];
                  this.submitDisable = true;
                  clearTimeout(this.validationTimeout);
                }
              });
          });

          const summaryPromise = getSummary({
            digitalServiceApmId: this.registrationData.digitalServiceApm,
            infraServiceApmId: this.registrationData.infrastructureServiceApm,
            environments: this.newEnvs,
          })
            .then((response) => {
              this.summary = response;
            })
            .catch((error) => {
              this.$notify('negative', 'Error', error.message);
            });

          await Promise.all([...validationPromises, summaryPromise]).finally(() => {
            this.loadSend = false;
            this.loadSummary = false;
          });
        }, 3000);
      }
    },
    showWorkflow(event, id) {
      supportCntrlClick(event, `/workflows?itemId=${id}`);
    },
    storedEnvironments() {
      const storedData = JSON.parse(localStorage.getItem('registrationData')) || {};
      return storedData[this.registrationId] || [];
    },
    async load() {
      this.$showLoading();
      this.loadData = false;
      try {
        const data = await getRegistration(this.registrationId, true, true);
        this.formData.environments = data.environments.map((env) => env.value);
        this.environments = data.environments.map((env) => ({ status: env.status, value: env.value, id: env.id }));
        this.details = data && data?.details ? data?.details[0] : undefined;

        let storedData = JSON.parse(localStorage.getItem('registrationData')) || {};
        let storedEnvs = storedData[this.registrationId] || [];

        storedData[this.registrationId] = storedEnvs.filter((env) => !this.environments.some((e) => e.value === env));

        if (storedData[this.registrationId].length === 0) {
          delete storedData[this.registrationId];
        }

        this.formData.environments = [...new Set([...this.formData.environments, ...storedEnvs])];

        localStorage.setItem('registrationData', JSON.stringify(storedData));

        subValWorkflow({
          workflowId: `engprt.onboard-application-default`,
          inputVariables: {
            digitalServiceApmId: this.registrationData.digitalServiceApm,
            infraServiceApmId: this.registrationData.infrastructureServiceApm,
          },
          subSchemaId: 'add-button',
        })
          .then(() => {
            this.addEnvError = undefined;
          })
          .catch((error) => {
            this.addEnvError = error.message;
          });
        const relatedWorkflowsPrmises = this.environments.map((env) => {
          return getRelatedWorkflowsStatuses(env.id).then((response) => {
            this.relatedWorkflowStatuses.push({ id: env.id, statuses: response });
          });
        });
        await Promise.all([...relatedWorkflowsPrmises]);
      } catch (error) {
        this.$notify('negative', 'Error', error.message);
      } finally {
        this.loadData = true;
        this.$hideLoading();
      }
    },
  },
  async mounted() {
    const { inputVariablesSchema: dbaasSchema } = await getBluePrint('engprt.post-onboarding-dbaas');
    delete dbaasSchema.$async;
    delete dbaasSchema.$schema;
    this.detailsSchema = dbaasSchema;
    await this.load();
  },
};
</script>

<style lang="scss" scoped>
.label-block {
  font-size: 20px;
  font-weight: bold;
}
.btns {
  min-width: 250px;
}
.env-form {
  background-color: var(--q-accent);
  padding-top: 8px;
  margin-bottom: 15px;
  border-top: 1px solid $grey-4;
  border-bottom: 1px solid $grey-4;
}
.environments {
  &.read-widget {
    .block-label {
      margin-bottom: 5px;
    }
    li {
      padding: 10px;
    }
  }
  ul {
    display: flex;
    flex-wrap: wrap;
    margin: 0 -5px;
    padding: 0;
  }

  li {
    width: calc(33.333% - 10px);
    margin: 0 5px;
    font-weight: bold;
    padding: 25px;
    border: 1px solid $grey-4;
    border-radius: 10px;
    display: flex;
    align-items: center;

    @media (max-width: $breakpoint-sm-max) {
      width: 100%;
      margin-bottom: 5px;
    }
  }
}
.widget-section {
  border-radius: 15px;
  background-color: white;
  padding: 30px;

  ul {
    display: flex;
    flex-wrap: wrap;
    margin: 0 -5px;
    padding: 0;
  }

  li {
    width: calc(33.333% - 10px);
    margin: 0 5px;
    font-weight: bold;
    padding: 25px;
    border: 1px solid $grey-4;
    border-radius: 10px;
    display: flex;
    align-items: center;

    @media (max-width: $breakpoint-sm-max) {
      width: 100%;
      margin-bottom: 5px;
    }
  }

  ul.roles {
    li {
      padding: 3px 0;
      border: none;
    }
  }
}
.label-block {
  font-size: 20px;
  font-weight: bold;
}
.btns {
  min-width: 175px;
}
.env-form {
  background-color: var(--q-accent);
  padding: 18px 6px 10px;
  margin-bottom: 20px;
  border-top: 1px solid $grey-4;
  border-bottom: 1px solid $grey-4;
}
.details {
  li {
    font-weight: normal;
  }
}
.summary {
  white-space: pre-line;
}
</style>
